/**
 * Pending changes emit type
 */
export enum PendingChangesEmitType {
    DISCARD = 'discard',
    LOGOUT = 'logout',
    REVIEW = 'review',
}
